import { render, staticRenderFns } from "./longtail.vue?vue&type=template&id=841c37a8&"
import script from "./longtail.vue?vue&type=script&lang=js&"
export * from "./longtail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports